(function () {
  'use strict';

  /* @ngdoc object
   * @name targetHours
   * @description
   *
   */
  angular
    .module('targetHours', [
      'ui.router'
    ]);
}());
